import {TaxRate} from "./tax-rate";

export class TaxRateMapper {
  public static map(data: any): TaxRate {
    let taxRate: TaxRate = new TaxRate();
    taxRate.id = data.id || '*';
    taxRate.class = data.class || '*';
    taxRate.country = data.country || '*';
    taxRate.state = data.state || '*';
    taxRate.postcode = data.postcode || '*';
    taxRate.city = data.city || '*';
    taxRate.rate = data.rate || '*';
    taxRate.name = data.name || '*';
    taxRate.priority = data.priority || '*';
    taxRate.compound = data.compound || false;
    taxRate.shipping = data.shipping || false;
    return taxRate;
  }

}
